import { type ComponentPropsWithoutRef, createElement, forwardRef, type ReactNode } from 'react'

type SvgElementName = keyof SVGElementTagNameMap
export type SvgProps<T extends SvgElementName = 'svg'> = ComponentPropsWithoutRef<T> & {
  children?: ReactNode
  color?: string
  size?: number
}

function createSvgElement<T extends SvgElementName>(tag: T) {
  return forwardRef<SVGElementTagNameMap[T], SvgProps<T>>(function SvgElement(props, ref) {
    const { size, ...elementProps } = props as Record<string, unknown>
    return createElement(tag, {
      ...elementProps,
      ref,
      width: elementProps.width ?? size,
      height: elementProps.height ?? size,
    })
  })
}

const Svg = createSvgElement('svg')

// SvgXml: вставка готовой svg-разметки (иконки kartoy из Figma).
export const SvgXml = forwardRef<HTMLSpanElement, { xml: string; width?: number | string; height?: number | string }>(
  function SvgXmlComponent({ xml, width, height }, ref) {
    const sized = xml.replace('<svg ', '<svg style="width:100%;height:100%" ')

    return createElement('span', {
      ref,
      dangerouslySetInnerHTML: { __html: sized },
      style: { display: 'inline-flex', height, lineHeight: 0, width },
    })
  },
)

// biome-ignore lint/style/noDefaultExport: shim must mirror react-native-svg default export.
export default Svg
export { Svg }
export const Circle = createSvgElement('circle')
export const ClipPath = createSvgElement('clipPath')
export const Defs = createSvgElement('defs')
export const Ellipse = createSvgElement('ellipse')
export const G = createSvgElement('g')
export const Image = createSvgElement('image')
export const Line = createSvgElement('line')
export const LinearGradient = createSvgElement('linearGradient')
export const Mask = createSvgElement('mask')
export const Path = createSvgElement('path')
export const Pattern = createSvgElement('pattern')
export const Polygon = createSvgElement('polygon')
export const Polyline = createSvgElement('polyline')
export const RadialGradient = createSvgElement('radialGradient')
export const Rect = createSvgElement('rect')
export const Stop = createSvgElement('stop')
export const Text = createSvgElement('text')
export const TSpan = createSvgElement('tspan')
export const Use = createSvgElement('use')
